import { Box, Typography, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom'; 
import { Truncate } from '../../util/truncate';
import { useSelectedBusiness } from '../../redux/store';

const FloatingBusinessIndicator = () => {
  const navigate = useNavigate();
  const selectedBusiness = useSelectedBusiness();

  // If no business name is provided, don't render the indicator
  if (!selectedBusiness?.businessBasic?.name) return null;

  return (
    <Tooltip
      title={selectedBusiness.businessBasic.name}
      arrow
    >
      <Box
        sx={{
          position: "fixed",
          zIndex: 100,
          bottom: 16,
          right: 16,
          padding: "6px 6px",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.2)",
          borderRadius: "8px",
          cursor: "pointer",
          "&:hover": {
            backgroundColor: "#f5f5f5",
          },
        }}
        onClick={() => navigate('/biz/profile')}
      >
        <Typography
          variant="body2"
          sx={{ fontSize: "0.75rem" }}
        >
          {Truncate(selectedBusiness.businessBasic.name, 15)}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default FloatingBusinessIndicator;
